import React, { useState, useEffect } from 'react'
import { Modal, Form, Button, Icon, Row, Col, Radio, Input, DatePicker, Select, InputNumber, Switch, Anchor, Table, Cascader, message, Checkbox, AutoComplete } from 'antd'
import styles from './index.less'
import { MARITAL_STATUS_ENUM, EDUCATION_ENUM, GENDER_ENUM, CLINIC_KEY } from '@/utils/consts'
import { queryProvinces, queryCities, queryAreas, queryChannels, queryProblems, quertDictsItem, checkPersonalPhoneExist, checkPersonalPhoneInfo, checkPersonalWeixinIdExist, checkPersonalNameExist, queryConsultantAll, queryQestionnaire } from '@/services/basicinfo'
import moment from 'moment'
import config from '@/utils/config'
import ClinicUserPicker from '@/components/ClinicUserPicker'
const { Column } = Table
const { Link } = Anchor
const { Option, OptGroup } = Select
const { TextArea } = Input

const { storageKeys: { formLayoutKey }, formLayoutConfig } = config

function disabledDate(current) {
  // Can not select days before today and today
  return current && current > moment().startOf('day')
}

function disabledDocumentDate(current) {
  // Can not select days before today and today
  return current && current > moment().subtract(0, "days")
  // return current && current >= moment().startOf('day')
}

let timer = null

const PersonalFormModal = ({ data = {}, customerStatus, classification, ConsultantList: consultantList, ClinicEmployee, clinicUserList, clinicId, jobs, onOk, onCancel, form, type, title, btnLoading, loading, modalType, customerStatusList, frequentEmployee = {}, ...modalProps }) => {
  const { getFieldDecorator, setFieldsValue, validateFields, getFieldValue, setFields, getFieldsValue } = form
  const { consultant_doctor = [], personal_doctor = [] } = frequentEmployee
  const [birthdayMode, setBirthdayMode] = useState('year')
  const [documentMode, setDocumentMode] = useState('year')
  const [layout, setLayout] = useState('compact')
  const [sChannelsOptions, setSChannelsOptions] = useState([])
  const [customerL1, setCustomerL1] = useState('')
  const [l2Options, setL2Options] = useState([])

  useEffect(() => {
    const cacheLayout = window.localStorage.getItem(formLayoutKey)
    if (cacheLayout && cacheLayout !== layout) {
      setLayout(cacheLayout)
    }
    // 设置一级客户的状态
    initCustomerStatus(data.customerStatusId)
  }, [])

  const handleOk = () => {

    validateFields((errors, values) => {
      if (errors) {
        return
      }
      if (!values.phone && !values.weixinId) {
        message.error('手机号和微信号至少填写一项')
        return
      }
      const {
        liveCity,
        birthday,
        fatherName,
        fatherAge,
        fatherEmergency,
        fatherOccupation,
        fatherPhone,
        motherName,
        motherAge,
        motherEmergency,
        motherOccupation,
        motherPhone,
        contactName,
        relation,
        phone,
        weixinId,
        contactEmergency,
        contactPhone,
        secondChannelName,
        questionType,     // 所属标签
        questionTypeTwo, // 所属类型
        attachCenter,    // 所属中心
        customerStatusId, // 一级客户状态
        customerStatusTwoId, // 二级客户状态
        contactAge,  // 其他联系人-年龄
        occupation, // 其他联系人-关系
        contactOccupation,
        fatherRelation,
        motherRelation,
        ...params
      } = values

      let questions = ''
      if (questionType && questionType.length > 0) {
        questions = questionType.join(',')
      }
      let secondChannel = {}
      if (secondChannelName) {
        secondChannel.name = secondChannelName
        secondChannel.parentId = params.firstChannelId
        secondChannel.clinicId = clinicId
        secondChannel.type = 'clinic'
      }

      let customerStatus = ''
      let customerStatusTwo = ''
      // 给id匹配中文
      if (customerStatusId || customerStatusTwoId) {
        customerStatus = (customerStatusList.filter(i => i.id == customerStatusId)[0] || {}).statusName
        customerStatusTwo = (l2Options.filter(i => i.id == customerStatusTwoId)[0] || {}).statusName
      }

      // 校验日期格式
      if (birthday) {
        if (moment(birthday, 'YYYYMMDD', true).isValid() || moment(birthday, 'YYYY-MM-DD', true).isValid()) {
        } else {
          return message.error('出生日期错误')
        }
      }

      const formData = {
        ...params,
        occupation,
        consultantDoctorId: localStorage.getItem('fulcrum-ancare-role-code') === 'ROLE_ASSISTANT' ? data.consultantDoctorId : params.consultantDoctorId,
        personalDoctorId: localStorage.getItem('fulcrum-ancare-role-code') === 'ROLE_ASSISTANT' ? data.personalDoctorId : params.personalDoctorId,
        id: data.customerId || undefined,
        type: data.customerId ? undefined : type,
        secondChannel: params.secondChannelId ? undefined : secondChannel,
        provinceId: liveCity && liveCity.length === 2 ? liveCity[0] : undefined,
        cityId: liveCity && liveCity.length === 2 ? liveCity[1] : undefined,
        // countyId: liveCity && liveCity.length === 3 ? liveCity[2] : undefined,
        birthday: birthday && moment(birthday).format('YYYY-MM-DD'),
        questionType: questions,
        phone: phone || undefined,
        weixinId: weixinId || undefined,
        questionTypeTwo, // 所属类型
        attachCenter,    // 所属中心
        customerStatus: customerStatus || '',
        customerStatusTwo: customerStatusTwo || '',
        customerStatusId: customerStatusId || '',
        customerStatusTwoId: customerStatusTwoId || '',
        hadCounseling: data.hadCounseling || null,
        timeInstitution: data.timeInstitution || null,
        customerFamilies: [{
          id: data.fatherId || undefined,
          name: fatherName || '',
          telephone: fatherPhone || '',
          emergency: fatherEmergency || '',
          age: fatherAge || '',
          relation: fatherRelation || '',
          occupation: fatherOccupation || '',
          sort: 1
        }, {
          id: data.motherId || undefined,
          name: motherName || '',
          age: motherAge || '',
          relation: motherRelation || '',
          emergency: motherEmergency || '',
          telephone: motherPhone || '',
          occupation: motherOccupation || '',
          sort: 2
        }]
      }

      formData.customerFamilies.push({
        id: data.contactId || undefined,
        name: contactName || '',
        relation: relation || '',
        age: contactAge || '',
        occupation: contactOccupation || '',
        telephone: contactPhone || '',
        emergency: contactEmergency || '',
        sort: 3
      })

      if (timer !== null) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        onOk(formData)
      }, 300)
    })
  }

  const handleChangeLayout = (val) => {
    setLayout(val)
    window.localStorage.setItem(formLayoutKey, val)
  }

  const formTitle = (
    <div className={styles.modalHeader}>
      <div className="modal-left">{title}</div>
      <div className="modal-right">
        <Button.Group style={{ marginRight: 12 }}>
          <Button type={layout === 'compact' ? 'primary' : 'default'} onClick={() => handleChangeLayout('compact')}>
            紧凑
          </Button>
          <Button type={layout === 'loose' ? 'primary' : 'default'} onClick={() => handleChangeLayout('loose')}>
            宽松
          </Button>
        </Button.Group>
        <Button
          type="primary"
          // loading={btnLoading} 
          onClick={() => handleOk()}
          style={{ marginRight: 12 }}
          loading={loading.effects[`personalPotentialList/${modalType}PotentialCustomer`]}
        >
          <Icon type="save" /> 保存
        </Button>
        <Button onClick={() => onCancel()}>取消</Button>
      </div>
    </div>
  )


  const [regionDatas, setRegionDatas] = useState([])
  const [fChannels, setFChanels] = useState([])
  const [sChannels, setSChanels] = useState([])
  const [problemTree, setProblemTree] = useState([])
  // const [classification, setClassification] = useState([])

  useEffect(() => {
    queryProvinces().then(async (res) => {
      const { code } = res
      if (code === 0 && res.data && res.data.length > 0) {
        const zhejiang = res.data.some(_ => _.name === '浙江省') ? res.data.filter(_ => _.name === '浙江省') : []
        const hunan = res.data.some(_ => _.name === '湖南省') ? res.data.filter(_ => _.name === '湖南省') : []
        const shanxi = res.data.some(_ => _.name === '陕西省') ? res.data.filter(_ => _.name === '陕西省') : []
        const sortProvince = [...zhejiang, ...hunan, ...shanxi, ...res.data.filter(_ => _.name !== '浙江省' && _.name !== '湖南省' && _.name !== '陕西省')]
        if (data.liveCity && data.liveCity.length === 2) {

          const resc = await queryCities({ id: data.liveCity[0] })

          // const resa = await queryAreas({ id: data.liveCity[1] })
          if (code === 0 && resc.data && resc.data.length > 0) {
            sortProvince.map(_ => {
              if (_.id === data.liveCity[0]) {
                _.children = resc.data.map((_c) => {
                  // _c.isLeaf = true
                  // if(_c.id === data.liveCity[1]) {
                  //   _c.children = resa.data
                  // }
                  return _c
                })
              }
              return _
            })
          }
        }
        setRegionDatas([...regionDatas])
        setRegionDatas(sortProvince.map(_ => {
          _.isLeaf = false
          return _
        }))
      }
    })
    queryChannels({ level: 1, clinicId: localStorage.getItem(CLINIC_KEY) }).then((res) => {
      const { code, data } = res
      if (code === 0 && data && data.length > 0) {
        setFChanels(data)
      }
    })
    if (data.firstChannelId) {
      querySChannels(data.firstChannelId)
    }
    queryProblemTree()
    // queryDictionaryClassification()
  }, [])

  // 查询问题类型
  const queryProblemTree = () => {
    queryProblems({}).then((res) => {
      const { code, data } = res
      if (code === 0 && data && data.length > 0) {
        data.map((_, i) => {
          _.title = _.name
          _.value = _.name
          _.isLeaf = false
          _.disabled = true
          if (_.children && _.children.length > 0) {
            _.children.map((c, idx) => {
              c.title = c.name
              c.value = c.name
              c.isLeaf = true
              return c
            })
          }
          return _
        })
        setProblemTree(data)
      }
    })
  }

  const handleFilterItem = (val, option) => {
    if (!option.props.pinyin) return true
    const pinyin = option.props.pinyin.toLowerCase()
    const name = option.props.name
    const input = val.toLowerCase()
    return pinyin.indexOf(input) > -1 || name.indexOf(input) > -1
  }

  const loadData = (selectedOptions) => {
    const len = selectedOptions.length
    const targetOption = selectedOptions[len - 1]
    targetOption.loading = true

    if (len === 1) {
      queryCities({ id: targetOption.id }).then(res => {
        targetOption.loading = false
        const { code, data } = res
        if (code === 0 && data && data.length > 0) {
          targetOption.children = data.map((_) => {
            _.isLeaf = true
            return _
          })
          setRegionDatas([...regionDatas])
        }
      })
    }
    // else if(len === 2) {
    //   queryAreas({ id: targetOption.id }).then(res => {
    //     targetOption.loading = false
    //     const { code, data } = res
    //     if(code === 0 && data && data.length > 0) {
    //       targetOption.children = data.map((_) => {
    //         _.isLeaf = true
    //         return _
    //       })
    //       setRegionDatas([...regionDatas])
    //     }
    //   })
    // }
  }

  const handleChangeFChannel = val => {
    setFieldsValue({ secondChannelId: undefined, secondChannelName: undefined })
    data.secondChannelName = undefined
    data.secondChannelId = undefined
    setSChanels([])
    setSChannelsOptions([])
    querySChannels(val)
  }

  const querySChannels = parentId => {
    queryChannels({ parentId, clinicId: localStorage.getItem(CLINIC_KEY) }).then((res) => {
      const { code, data } = res
      if (code === 0 && data && data.length > 0) {
        let newData = []
        data.map(_ => newData.push({ value: _.name, enable: _.enable }))
        setSChannelsOptions(newData)
        setSChanels(data)
      }
    })
  }

  const handleValid = (ele) => {
    setTimeout(() => {
      validateFields([ele], { force: true })
    }, 10)
  }

  // 手机号唯一判断
  const checkPhone = async (rule, value, callback) => {
    const pattern = /^1[3-9]\d{9}$/
    if (value) {
      if (!pattern.test(value)) {
        callback('格式错误')
      } else {
        const res = await checkPersonalPhoneExist({ phone: value, id: data.customerId || undefined })
        console.log('bugres---', res) // 查bug
        try {
          if (res.data) {
            // 获取存在的客户信息
            const { data = [] } = await checkPersonalPhoneInfo({ phone: value })
            const showPhoneInfo = () => {
              Modal.info({
                width: 500,
                title: '客户信息',
                content: (
                  <Table dataSource={[data]} pagination={false} size='small'>
                    <Column title='所在门店' dataIndex='clinicName' />
                    <Column title='顾客姓名' dataIndex='customerName' />
                    <Column title='心理顾问' dataIndex='consultantName' />
                    <Column title='已服务次数' dataIndex='serviceCount' />
                    <Column title='消耗金额' dataIndex='consumptionAmount' />
                  </Table>
                ),
              })
            }
            callback(<span>手机号已存在 <a onClick={showPhoneInfo}>点击查看详情</a></span>)
          } else {
            callback()
          }
        } catch (error) {
          console.log('error', error)
          message.error(error, 10)
        }
      }
    }
  }

  // 微信唯一性
  const checkWeixinId = async (rule, value, callback) => {
    if (value) {
      const res = await checkPersonalWeixinIdExist({ wechatId: value, id: data.customerId || undefined })
      if (res.data) {
        callback('微信号已存在')
      } else {
        callback()
      }
    }
  }

  // 客户姓名判断
  const checkName = async (value) => {
    if (value) {
      const res = await checkPersonalNameExist({ name: value, id: data.customerId || undefined })
      if (res.data) {
        message.warn(`姓名${value}已存在,请确定客户是否重复`)
      }
    }
  }

  //其他联系人，新增／编辑，当输入值的时候，关系默认为其他，可以编辑修改。 如果姓名的值删掉，关系清空
  const onContactNameChange = (e) => {
    if (e.target.value) {
      if (!getFieldValue('relation')) {
        setFieldsValue({ relation: '其他' })
      }
    } else {
      // setFieldsValue({relation:undefined})
    }
  }

  // 一级改变时的状态
  const onCustomerL1Change = (e) => {
    let l2Options = customerStatusList.filter(i => i.id == e)[0] || {}
    l2Options = (l2Options.statusVoList || []).filter(i => i.locked == 0)
    setCustomerL1(e)
    setFieldsValue({ customerStatusTwoId: void 0 })
    setL2Options(l2Options)
  }
  const initCustomerStatus = (id) => {
    let l2Options = customerStatusList.filter(i => i.id == id)[0] || {}
    l2Options = (l2Options.statusVoList || []).filter(i => i.locked == 0)
    setL2Options(l2Options)
  }

  return (
    <Modal
      {...modalProps}
      className={styles.modal}
      closable={false}
      title={formTitle}
    >
      <div className={styles.modalContent} id="modal-form">
        {formLayoutConfig[layout].showAnchr && <div className={styles.formAnchor}>
          <Anchor offsetTop={20} getContainer={() => {
            const dom = document.getElementById('modal-form').parentNode
            return dom
          }}	>
            <Link href="#basic-info" title="基本信息" />
            <Link href="#family" title="家庭信息">
              <Link href="#family-father" title="父亲" />
              <Link href="#family-mother" title="母亲" />
              <Link href="#family-other" title="紧急联系人" />
            </Link>
            <Link href="#demands" title="需求描述" />
          </Anchor>
        </div>}
        <div className={styles.modalForm}>
          <Form layout="horizontal">
            <div className="form-group">
              <div className="form-group-header">
                <h3 id="basic-info">基本信息</h3>
              </div>
              <Row gutter={formLayoutConfig[layout].rowGutter}>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="姓名" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('name', {
                      initialValue: data.name,
                      rules: [
                        { required: true, message: '必填项' },
                      ],
                    })(
                      <Input size={formLayoutConfig[layout].formSize} onBlur={(e) => checkName(e.target.value)} />
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="性别" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('gender', {
                      initialValue: data.gender,
                    })(
                      <Radio.Group size={formLayoutConfig[layout].formSize}>
                        {GENDER_ENUM.map(_ => <Radio key={_.value} value={_.value}>{_.label}</Radio>)}
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="手机号码" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('phone', {
                      initialValue: data.phone,
                      rules: [
                        {
                          required: !getFieldValue('weixinId'),
                          message: '手机号或微信号必填一项'
                        },
                        {
                          validator: (rule, value, callback) => checkPhone(rule, value, callback),
                        }
                      ],
                    })(
                      <Input placeholder="手机号或微信号必填一项" size={formLayoutConfig[layout].formSize} />
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="微信号" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('weixinId', {
                      initialValue: data.weixinId,
                      rules: [
                        {
                          required: !getFieldValue('phone'),
                          message: '手机号或微信号必填一项'
                        },
                        {
                          validator: (rule, value, callback) => checkWeixinId(rule, value, callback),
                        }
                      ]
                    })(
                      <Input placeholder="手机号或微信号必填一项" size={formLayoutConfig[layout].formSize} />
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="建档时间" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('documentDate', {
                      initialValue: data.documentDate ? moment(data.documentDate) : moment(),
                      rules: [
                        {
                          required: true,
                          message: '必填项'
                        }
                      ],
                    })(
                      <DatePicker
                        getPopupContainer={() => document.getElementById('birthday')}
                        size={formLayoutConfig[layout].formSize}
                        // mode={documentMode} 
                        disabledDate={disabledDocumentDate}
                        // onPanelChange={(val, mode) => setDocumentMode(mode)} 
                        // onOpenChange={(open) => {
                        //   if(open) {
                        //     setDocumentMode('year')
                        //   }
                        // }}
                        style={{ width: '100%' }}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="身高" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('height', {
                      initialValue: data.height,
                      rules: [
                        {
                          pattern: /^[1-9]\d{0,2}(\.\d{1,1})?$/,
                          message: '格式错误'
                        },
                      ],
                    })(
                      <Input placeholder="请填写身高" addonAfter="cm" size={formLayoutConfig[layout].formSize} />
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="体重" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('weight', {
                      initialValue: data.weight,
                      rules: [
                        {
                          pattern: /^[1-9]\d{0,2}(\.\d{1,1})?$/,
                          message: '格式错误'
                        },
                      ],
                    })(
                      <Input placeholder="请填写体重" addonAfter="kg" size={formLayoutConfig[layout].formSize} />
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="婚姻状况" id="maritalStatus" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('maritalStatus', {
                      initialValue: data.maritalStatus,
                    })(
                      <Select
                        getPopupContainer={() => document.getElementById('maritalStatus')}
                        placeholder="请选择婚姻状况"
                        allowClear
                        size={formLayoutConfig[layout].formSize}
                      >
                        {MARITAL_STATUS_ENUM.map(_ => <Option key={_.value}>{_.label}</Option>)}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  {/* <Form.Item label="出生日期" id="birthday" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('birthday', {
                      initialValue: data.birthday ? moment(data.birthday) : null,
                    })(
                      <DatePicker
                        getPopupContainer={() => document.getElementById('birthday')}
                        size={formLayoutConfig[layout].formSize}
                        mode={birthdayMode}
                        disabledDate={disabledDate}
                        onPanelChange={(val, mode) => setBirthdayMode(mode)}
                        onOpenChange={(open) => {
                          if (open) {
                            setBirthdayMode('year')
                          }
                        }}
                        style={{ width: '100%' }}
                      />
                    )}
                  </Form.Item> */}
                  <Form.Item label="出生日期" id="birthday" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('birthday', {
                      initialValue: data.birthday,
                      rules: [
                        { required: true, message: '必填项' },
                        {
                          pattern: /^\d{4}-?\d{2}-?\d{2}$/,
                          message: '格式错误,如:19970801或1997-08-01'
                        },
                      ]
                    })(
                      <Input placeholder='格式:19970801/1997-08-01' />
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="学历" id="education" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('education', {
                      initialValue: data.education,
                    })(
                      <Select placeholder="请选择学历" size={formLayoutConfig[layout].formSize}
                        getPopupContainer={() => document.getElementById('education')}>
                        {EDUCATION_ENUM.map(_ => <Option key={_.value}>{_.label}</Option>)}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col id="liveCity" span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="现居城市" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('liveCity', {
                      initialValue: data.liveCity,
                    })(
                      <Cascader
                        getPopupContainer={() => document.getElementById('liveCity')}
                        size={formLayoutConfig[layout].formSize}
                        options={regionDatas}
                        changeOnSelect
                        popupClassName={styles.cascader}
                        loadData={(selectedOptions) => loadData(selectedOptions)}
                        fieldNames={{ label: 'name', value: 'id' }}
                        placeholder="请选择居住城市"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="职业" id="occupation" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('occupation', {
                      initialValue: data.occupation,
                    })(
                      <Input size={formLayoutConfig[layout].formSize} />
                      // <Select
                      //   placeholder="请选择职业"
                      //   size={formLayoutConfig[layout].formSize}
                      //   allowClear
                      //   showSearch
                      //   filterOption={(val, option) => handleFilterItem(val, option)}
                      //   getPopupContainer={() => document.getElementById('occupation')}
                      // >
                      //   {(jobs || []).map(_ => <Option pinyin={_.description} name={_.key} key={_.value}>{_.key}</Option>)}
                      // </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="居住地址" labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                    {getFieldDecorator('liveAddress', {
                      initialValue: data.liveAddress,
                    })(
                      <Input size={formLayoutConfig[layout].formSize} />
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <div className="form-group">
              <div className="form-group-header">
                <h3 id="basic-info">服务信息</h3>
              </div>
              <Row gutter={formLayoutConfig[layout].rowGutter}>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="一级渠道" id="firstChannelId" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('firstChannelId', {
                      initialValue: data.firstChannelId ? Number(data.firstChannelId) : undefined,
                      rules: [
                        {
                          required: true,
                          message: '必填项'
                        },

                      ],
                    })(
                      <Select
                        size={formLayoutConfig[layout].formSize}
                        placeholder="请选择一级渠道"
                        allowClear
                        onChange={(val) => handleChangeFChannel(val)}
                        showSearch
                        filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                        getPopupContainer={() => document.getElementById('firstChannelId')}
                      >
                        <OptGroup label="通用渠道">
                          {/* {fChannels.filter(_ => _.type !== 'clinic').map(_ => <Option disabled={!_.enable} key={_.id} value={_.id}>{_.name}</Option>)} */}
                          {fChannels.filter(_ => _.type !== 'clinic').filter((_) => { return modalType === 'add' ? _.enable : (_.enable || (data.firstChannelId ? Number(data.firstChannelId) === _.id : false)) }).map(_ => <Option disabled={!_.enable} key={_.id} value={_.id}>{_.name}</Option>)}

                        </OptGroup>
                        <OptGroup label="自定义渠道">
                          {/* {fChannels.filter(_ => _.type === 'clinic').map(_ => <Option disabled={!_.enable} key={_.id} value={_.id}>{_.name}</Option>)} */}
                          {fChannels.filter(_ => _.type === 'clinic').filter((_) => { return modalType === 'add' ? _.enable : (_.enable || (data.firstChannelId ? Number(data.firstChannelId) === _.id : false)) }).map(_ => <Option disabled={!_.enable} key={_.id} value={_.id}>{_.name}</Option>)}
                        </OptGroup>
                        {/* { fChannels.map(_ => <Option key={_.id} value={_.id}>{_.name}</Option>)} */}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                {(!getFieldValue('firstChannelId') || (getFieldValue('firstChannelId') && fChannels && fChannels.filter(_ => _.id === getFieldValue('firstChannelId')).length > 0 && fChannels.filter(_ => _.id === getFieldValue('firstChannelId'))[0].type !== 'clinic')) && <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="二级渠道" id="secondChannelId" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('secondChannelId', {
                      initialValue: data.secondChannelId ? Number(data.secondChannelId) : undefined,
                      rules: [
                        {
                          required: true,
                          message: '必填项'
                        },

                      ],
                    })(
                      <Select
                        placeholder="请选择二级渠道" size={formLayoutConfig[layout].formSize}
                        disabled={!getFieldValue('firstChannelId')}
                        allowClear
                        getPopupContainer={() => document.getElementById('secondChannelId')}
                        showSearch
                        filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                      >
                        {/* {sChannels.map(_ => <Option disabled={!_.enable} key={_.id} value={_.id}>{_.name}</Option>)} */}
                        {sChannels.filter((_) => { return modalType === 'add' ? _.enable : (_.enable || (data.secondChannelId ? Number(data.secondChannelId) === _.id : false)) }).map(_ => <Option disabled={!_.enable} key={_.id} value={_.id}>{_.name}</Option>)}
                      </Select>
                    )}
                  </Form.Item>
                </Col>}
                {/* {(!data.secondChannelName && !getFieldValue('secondChannelName')) && (!getFieldValue('firstChannelId') || (getFieldValue('firstChannelId') && fChannels.filter(_ => _.id === getFieldValue('firstChannelId'))[0].type !== 'clinic')) && <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="二级渠道" id="secondChannelId" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('secondChannelId', {
                      initialValue: data.secondChannelId ? Number(data.secondChannelId) : undefined,
                    })(
                      <Select 
                        placeholder="请选择二级渠道" size={formLayoutConfig[layout].formSize}
                        disabled={!getFieldValue('firstChannelId')}
                        allowClear
                        getPopupContainer={() => document.getElementById('secondChannelId')}
                      >
                        {sChannels.map(_ => <Option key={_.id} value={_.id}>{_.name}</Option>)}
                      </Select>
                    )}
                  </Form.Item>
                </Col>} */}
                {((fChannels && getFieldValue('firstChannelId') && (fChannels.filter(_ => _.id === getFieldValue('firstChannelId'))[0] || {}).type === 'clinic')) && <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="二级渠道" id="secondChannelId" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('secondChannelName', {
                      initialValue: data.secondChannelName,
                    })(
                      <AutoComplete
                        size={formLayoutConfig[layout].formSize}
                        options={sChannelsOptions}
                        placeholder='请输入二级渠道'
                        showSearch
                        filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                      >
                        {/* {sChannelsOptions && sChannelsOptions.map(_ => <Option disabled={!_.enable} value={_.value}>{_.value}</Option>)} */}
                        {sChannelsOptions && sChannelsOptions.filter((_) => { return modalType === 'add' ? _.enable : (_.enable || (data.secondChannelName ? data.secondChannelName === _.value : false)) }).map(_ => <Option disabled={!_.enable} value={_.value}>{_.value}</Option>)}
                      </AutoComplete>
                      // <Input placeholder='请输入二级渠道' size={formLayoutConfig[layout].formSize} />
                    )}
                  </Form.Item>
                </Col>}
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="客户级别" id="classification" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('classification', {
                      initialValue: data.classification,
                      rules: [{ required: true, message: '必填项' }]
                    })(
                      <Select
                        placeholder="请选择客户级别" size={formLayoutConfig[layout].formSize}
                        allowClear
                        getPopupContainer={() => document.getElementById('classification')}
                      >
                        {/* 1.enabled = false &&  */}
                        {classification && classification.map(_ => <Option disabled={data.classification != _.value && !_.enabled} key={_.value} value={_.value}>{_.key}</Option>)}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="可预约时间" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('appointmentHabit', {
                      initialValue: data.appointmentHabit,
                    })(
                      <Input size={formLayoutConfig[layout].formSize} />
                    )}
                  </Form.Item>
                </Col>
                {/* 在线医助角色不填心理顾问 */}
                {localStorage.getItem('fulcrum-ancare-role-code') === 'ROLE_ASSISTANT' ? '' : (clinicId && <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="心理顾问" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('consultantDoctorId', {
                      initialValue: data.consultantDoctorId && (modalType === 'add' ? (clinicUserList.filter(_ => _.locked ? !_.locked : _.enable).map(_ => _.userId).includes(Number(data.consultantDoctorId)) && data.consultantDoctorId) : data.consultantDoctorId) || undefined,
                      rules: [
                        {
                          required: true,
                          message: '必填项'
                        }
                      ],
                    })(
                      <Select
                        size={formLayoutConfig[layout].formSize}
                        getPopupContainer={triggerNode => triggerNode.parentNode}
                        disabled={data.customerId && localStorage.getItem('fulcrum-ancare-role-code') !== 'ROLE_CLINIC_ADMIN' && localStorage.getItem('fulcrum-ancare-role-code') !== 'ROLE_CONSULTANT' && localStorage.getItem('fulcrum-ancare-role-code') !== 'ROLE_GUIDE'}
                        placeholder="请选择心理顾问"
                        showSearch
                        filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                      >
                        <OptGroup label='常用人选'>
                          {
                            consultant_doctor.map(i => {
                              return <Option value={`${i.userId}`}>{i.name}</Option>
                            })
                          }
                        </OptGroup>
                        {clinicUserList && clinicUserList.map(_ => <Option value={_.userId} key={_.id}>{_.name}</Option>)}
                      </Select>
                    )}
                  </Form.Item>
                </Col>)}
                {/* 在线医助角色不填私人管家 */}
                {localStorage.getItem('fulcrum-ancare-role-code') === 'ROLE_ASSISTANT' ? '' : (clinicId && <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="私人管家" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('personalDoctorId', {
                      initialValue: data.personalDoctorId,
                      rules: [
                        {
                          required: true,
                          message: '必填项'
                        }
                      ],
                    })(
                      <ClinicUserPicker
                        frequentList={personal_doctor}
                        ClinicEmployee={ClinicEmployee}
                        disabled={data.customerId && localStorage.getItem('fulcrum-ancare-role-code') !== 'ROLE_CLINIC_ADMIN' && localStorage.getItem('fulcrum-ancare-role-code') !== 'ROLE_CONSULTANT' && localStorage.getItem('fulcrum-ancare-role-code') !== 'ROLE_GUIDE'}
                        size={formLayoutConfig[layout].formSize}
                        roleName='私人管家'
                        clinicId={clinicId}
                        from={'personal'}
                        modalType={modalType}
                        initialValue={data.personalDoctorId}
                      />
                    )}
                  </Form.Item>
                </Col>)}
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="一级客户状态" id="customerStatusId" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('customerStatusId', {
                      initialValue: data.customerStatusId,
                      rules: [{ required: true, message: '必填项' }]
                    })(
                      <Select
                        placeholder="请选择一级客户状态" size={formLayoutConfig[layout].formSize}
                        onChange={onCustomerL1Change}
                        allowClear
                        getPopupContainer={() => document.getElementById('customerStatusId')}
                      >
                        {customerStatusList && customerStatusList.map(_ => <Option disabled={!_.addAble} key={_.id} value={_.id}>{_.statusName}</Option>)}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="二级客户状态" id="customerStatusTwoId" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('customerStatusTwoId', {
                      initialValue: data.customerStatusTwoId,
                      rules: [{ required: true, message: '必填项' }]
                    })(
                      <Select
                        placeholder="请选择二级客户状态" size={formLayoutConfig[layout].formSize}
                        allowClear
                        getPopupContainer={() => document.getElementById('customerStatusTwoId')}
                      >
                        {
                          l2Options &&
                          l2Options.map(_ => <Option key={_.id} value={_.id}>{_.statusName}</Option>)
                        }
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="问题类型" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('questionTypeTwo', {
                      initialValue: data.questionTypeTwo,
                      rules: [{ required: true, message: '必填项' }]
                    })(
                      <Input size={formLayoutConfig[layout].formSize} />
                    )}
                  </Form.Item>
                </Col>
                <Col span={13}>
                  <Form.Item label="所属中心" {...formLayoutConfig[layout].familyItemLayout}>
                    {getFieldDecorator('attachCenter', {
                      initialValue: data.attachCenter,
                      rules: [{ required: true, message: '所属中心是必填项' }]
                    })(
                      <Radio.Group>
                        <Radio value={1}>儿童心理</Radio>
                        <Radio value={2}>青少年心理</Radio>
                        <Radio value={3}>人际职场+个人成长</Radio>
                        <Radio value={4}>恋爱婚姻</Radio>
                        <Radio value={5}>情绪睡眠+心理疾病</Radio>
                        <Radio value={6}>不确定</Radio>
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={12}>
                  <Form.Item label="核心诉求" labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                    {getFieldDecorator('coreRequirement', {
                      initialValue: data.coreRequirement
                    })(
                      <TextArea maxLength={1000} size={formLayoutConfig[layout].formSize} autoSize={{ minRows: 3, maxRows: 10 }} />
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="备注" labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                    {getFieldDecorator('comment', {
                      initialValue: data.comment,
                      rules: [
                        {
                          max: 100,
                          message: '请输入小于100个字符'
                        },
                      ],
                    })(
                      <TextArea placeholder='请输入小于100个字符' size={formLayoutConfig[layout].formSize} autoSize={{ minRows: 3, maxRows: 10 }} />
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <div className="form-group">
              <div className="form-group-header">
                <h3 id="family">家庭信息</h3>
              </div>
              <div className="form-multi">
                {/* <div className="form-multi-header">
                  <h4 id="family-father">父亲</h4>
                </div> */}
                <Row gutter={formLayoutConfig[layout].rowGutter}>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="姓名" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('fatherName', {
                        initialValue: data.fatherName,
                      })(
                        <Input placeholder="请填写联系人姓名" size={formLayoutConfig[layout].formSize} />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="关系" id="fatherRelation" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('fatherRelation', {
                        initialValue: data.fatherRelation,
                      })(
                        <Input size={formLayoutConfig[layout].formSize} />
                        // <Select
                        //   allowClear={modalType === 'add' ? true : false}
                        //   size={formLayoutConfig[layout].formSize}
                        //   placeholder="请选择关系"
                        //   getPopupContainer={() => document.getElementById('relation')}
                        // >
                        //   <Option value="丈夫">丈夫</Option>
                        //   <Option value="妻子">妻子</Option>
                        //   <Option value="哥哥">哥哥</Option>
                        //   <Option value="姐姐">姐姐</Option>
                        //   <Option value="弟弟">弟弟</Option>
                        //   <Option value="妹妹">妹妹</Option>
                        //   <Option value="爷爷">爷爷</Option>
                        //   <Option value="奶奶">奶奶</Option>
                        //   <Option value="朋友">朋友</Option>
                        //   <Option value="同事">同事</Option>
                        //   <Option value="其他">其他</Option>
                        // </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="联系电话" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('fatherPhone', {
                        initialValue: data.fatherPhone,
                        rules: [
                          {
                            pattern: /^1[3-9]\d{9}$/,
                            message: '格式错误'
                          }
                        ]
                      })(
                        <Input size={formLayoutConfig[layout].formSize} />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="年龄" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('fatherAge', {
                        initialValue: data.fatherAge,
                      })(
                        <InputNumber style={{ width: 200 }} size={formLayoutConfig[layout].formSize} placeholder="请填写年龄" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="职业" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('fatherOccupation', {
                        initialValue: data.fatherOccupation,
                      })(
                        <Input size={formLayoutConfig[layout].formSize} />
                        // <Select
                        //   size={formLayoutConfig[layout].formSize}
                        //   placeholder="请选择职业"
                        //   showSearch
                        //   filterOption={(val, option) => handleFilterItem(val, option)}
                        // >
                        //   {(jobs || []).map(_ => <Option key={_.value} name={_.key} pinyin={_.description}>{_.key}</Option>)}
                        // </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="紧急联系人" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('fatherEmergency', {
                        initialValue: data.fatherEmergency,
                        valuePropName: 'checked'
                      })(
                        <Switch size={formLayoutConfig[layout].formSize} unCheckedChildren="否" checkedChildren="是" />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <div className="form-multi">
                {/* <div className="form-multi-header">
                  <h4 id="family-mother">母亲</h4>
                </div> */}
                <Row gutter={formLayoutConfig[layout].rowGutter}>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="姓名" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('motherName', {
                        initialValue: data.motherName,
                      })(
                        <Input size={formLayoutConfig[layout].formSize} placeholder="请填写联系人姓名" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="关系" id="motherRelation" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('motherRelation', {
                        initialValue: data.motherRelation,
                      })(
                        <Input size={formLayoutConfig[layout].formSize} />
                        // <Select
                        //   allowClear={modalType === 'add' ? true : false}
                        //   size={formLayoutConfig[layout].formSize}
                        //   placeholder="请选择关系"
                        //   getPopupContainer={() => document.getElementById('relation')}
                        // >
                        //   <Option value="丈夫">丈夫</Option>
                        //   <Option value="妻子">妻子</Option>
                        //   <Option value="哥哥">哥哥</Option>
                        //   <Option value="姐姐">姐姐</Option>
                        //   <Option value="弟弟">弟弟</Option>
                        //   <Option value="妹妹">妹妹</Option>
                        //   <Option value="爷爷">爷爷</Option>
                        //   <Option value="奶奶">奶奶</Option>
                        //   <Option value="朋友">朋友</Option>
                        //   <Option value="同事">同事</Option>
                        //   <Option value="其他">其他</Option>
                        // </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="联系电话" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('motherPhone', {
                        initialValue: data.motherPhone,
                        rules: [
                          {
                            pattern: /^1[3-9]\d{9}$/,
                            message: '格式错误'
                          }
                        ]
                      })(
                        <Input size={formLayoutConfig[layout].formSize} />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="年龄" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('motherAge', {
                        initialValue: data.motherAge,
                      })(
                        <InputNumber size={formLayoutConfig[layout].formSize} style={{ width: 200 }} placeholder="请填写年龄" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="职业" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('motherOccupation', {
                        initialValue: data.motherOccupation,
                      })(
                        <Input size={formLayoutConfig[layout].formSize} />
                        // <Select
                        //   size={formLayoutConfig[layout].formSize}
                        //   placeholder="请选择职业"
                        //   showSearch
                        //   filterOption={(val, option) => handleFilterItem(val, option)}
                        // >
                        //   {(jobs || []).map(_ => <Option name={_.key} pinyin={_.description} key={_.value}>{_.key}</Option>)}
                        // </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="紧急联系人" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('motherEmergency', {
                        initialValue: data.motherEmergency,
                        valuePropName: 'checked'
                      })(
                        <Switch size={formLayoutConfig[layout].formSize} unCheckedChildren="否" checkedChildren="是" />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <div className="form-multi">
                {/* <div className="form-multi-header">
                  <h4 id="family-mother">其他联系人</h4>
                </div> */}
                <Row gutter={formLayoutConfig[layout].rowGutter}>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="姓名" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('contactName', {
                        initialValue: data.contactName,
                      })(
                        <Input onChange={onContactNameChange} size={formLayoutConfig[layout].formSize} placeholder="请填写联系人姓名" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="关系" id="relation" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('relation', {
                        initialValue: data.relation,
                      })(
                        <Input size={formLayoutConfig[layout].formSize} />
                        // <Select
                        //   allowClear={modalType === 'add' ? true : false}
                        //   size={formLayoutConfig[layout].formSize}
                        //   placeholder="请选择关系"
                        //   getPopupContainer={() => document.getElementById('relation')}
                        // >
                        //   <Option value="丈夫">丈夫</Option>
                        //   <Option value="妻子">妻子</Option>
                        //   <Option value="哥哥">哥哥</Option>
                        //   <Option value="姐姐">姐姐</Option>
                        //   <Option value="弟弟">弟弟</Option>
                        //   <Option value="妹妹">妹妹</Option>
                        //   <Option value="爷爷">爷爷</Option>
                        //   <Option value="奶奶">奶奶</Option>
                        //   <Option value="朋友">朋友</Option>
                        //   <Option value="同事">同事</Option>
                        //   <Option value="其他">其他</Option>
                        // </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="联系电话" id="contactPhone" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('contactPhone', {
                        initialValue: data.contactPhone,
                        rules: [
                          {
                            pattern: /^1[3-9]\d{9}$/,
                            message: '格式错误'
                          }
                        ]
                      })(
                        <Input size={formLayoutConfig[layout].formSize} />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="年龄" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('contactAge', {
                        initialValue: data.contactAge,
                      })(
                        <InputNumber size={formLayoutConfig[layout].formSize} style={{ width: 200 }} placeholder="请填写年龄" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="职业" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('contactOccupation', {
                        initialValue: data.contactOccupation,
                      })(
                        <Input size={formLayoutConfig[layout].formSize} />
                        // <Select
                        //   size={formLayoutConfig[layout].formSize}
                        //   placeholder="请选择职业"
                        //   showSearch
                        //   filterOption={(val, option) => handleFilterItem(val, option)}
                        // >
                        //   {(jobs || []).map(_ => <Option name={_.key} pinyin={_.description} key={_.value}>{_.key}</Option>)}
                        // </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="紧急联系人" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('contactEmergency', {
                        initialValue: data.contactEmergency,
                        valuePropName: 'checked'
                      })(
                        <Switch unCheckedChildren="否" checkedChildren="是" />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </div>
            <div className="form-group">
              <div className="form-group-header">
                <h3 id="demands">需求描述</h3>
              </div>
              <Row>
                <Col span={24}>
                  <Form.Item label="问题标签" {...formLayoutConfig[layout].questionItemLayout}>
                    {getFieldDecorator('questionType', {
                      initialValue: data.questionType,
                    })(
                      <Checkbox.Group style={{ marginTop: 10 }}>
                        {problemTree.map(f => {
                          return (
                            <Row className={styles.questionWrapper}>
                              <div className="tree-parent">{f.title}</div>
                              <div className="tree-children">
                                {(f.children || []).map(c => {
                                  return <Checkbox value={c.value}>{c.title}</Checkbox>
                                })}
                              </div>
                            </Row>
                          )
                        })}
                      </Checkbox.Group>
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={formLayoutConfig[layout].rowGutter}>
                <Col span={12}>
                  <Form.Item label="其他" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('otherQuestion', {
                      initialValue: data.otherQuestion
                    })(
                      <TextArea size={formLayoutConfig[layout].formSize} autoSize={{ minRows: 3, maxRows: 10 }} />
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Form>
        </div>
      </div>

    </Modal>
  )
}

export default Form.create()(PersonalFormModal)